var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"record-wrapper"},[_c('div',{staticClass:"status",class:{'normal':_vm.asrSocketStatus}}),_c('div',{staticClass:"text-wrapper"},[_c('div',{staticClass:"question"},[_vm._v(_vm._s(_vm.question))]),_c('div',{staticClass:"answer"},[_vm._v(_vm._s(_vm.answer))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }